import { render, staticRenderFns } from "./WorkspaceDetail.vue?vue&type=template&id=f17de3b8&scoped=true&"
import script from "./WorkspaceDetail.vue?vue&type=script&lang=js&"
export * from "./WorkspaceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17de3b8",
  null
  
)

export default component.exports